const getSerialNumberFromVin = (vin: string) => {
  // Get the last 6 characters of the VIN
  const serialNumber = vin.slice(-6);
  return serialNumber;
};

export default getSerialNumberFromVin;
